export const INTERNAL = 'INTERNAL';
export const EXTERNAL = 'EXTERNAL';
export const ICC = 'ICC';
